
import TableList from "@components/templates/tablelist";
import { HttpGetPlatform,HttpFailurePlatform, HttpPlatform } from "@/service/managechannel/managechannel";
import { mapState } from "vuex";
import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    // EQ_shippingCarrier:'',
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            erpSkusList:[],
            platforms:[],
        };
    },
    created(){
        this.getplatformList();
        this.siteShipmentDel = this.handleAuth('erp.accountSiteShipment.del');
    },
    methods: {
        ajaxRequest: HttpGetPlatform,
        getplatformList(){
            HttpPlatform().then(res=>{
                this.platforms = res.data
            })
        },
        dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(type!='addpage'){
                if(batch){
                    params=(params||this.checkedData.join(','))+'';
                    if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
                }
            }
            switch (type) {
                case "addpage":
                    this.$router.push({
                        name: 'platformUpdate',
                        params: { type: "addpage" },
                    });
                    break;
                case "query":
                    
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "platformUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "edit":
                    this.$router.push({
                        name: 'platformUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;

                case "failure":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{id:params},
                        title: "失效操作",
                        ajaxRequest:HttpFailurePlatform
                    }
                    break;
                case "unfailure":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{id:params},
                        title: "生效操作",
                        // ajaxRequest:HttpFailurePlatform
                    }
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/AccountSiteShipping/export',{ids:params},'download');
                    break;
            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            // console.log(row)
            const { id, status } = row;
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show:status!='INACTIVE',
                params:id,
                operate:'edit'
            },{
                label:'失效',
                show:status!='INACTIVE' && this.siteShipmentDel,
                params:id,
                operate:'failure',
            },
            // {
            //     label:'生效',
            //     show:status=='INACTIVE',
            //     params:id,
            //     operate:'unfailure'
            // }
            ]
        },
    },
    computed: {
        ...mapState('boss', ['sysdeliveries','countries','allaccounties', 'newSysdeliveries']),
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: "添加",
                    operate: "addpage",
                    theme: "primary",
                    batch:true,
                },
                {
                    name: "批量导出",
                    operate: "export",
                    theme: "info",
                    batch:true,
                }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            const dropStyle="width:auto;min-width:250px;";
            let pingtai,accountType=[];
            let mingcheng,siteName=[];
            let zhuangtai,status=[];
            let guojia,siteCountry = [];
            let shippingcarrier,shippingCarrier = [];
            let shippingmethodcode,shippingMethodCode = [];
            this.platforms.map(function(item){
                accountType.push(item.accountType)
                siteName.push(item.siteName)
                status.push(item.status)
                siteCountry.push(item.siteCountry)
                if(item.shippingCarrier!=''){
                    shippingCarrier.push(item.shippingCarrier)
                }
                if(item.shippingMethodCode!=''){
                    shippingMethodCode.push(item.shippingMethodCode)
                }
            })
            pingtai = this.dedupe(accountType)
            mingcheng = this.dedupe(siteName)
            zhuangtai = this.dedupe(status)
            guojia = this.dedupe(siteCountry)
            shippingcarrier = this.dedupe(shippingCarrier)
            shippingmethodcode = this.dedupe(shippingMethodCode)
            return  [
                {
                    label: "平台类型",
                    tag: 'vSelect',
                    key: 'EQ_accountType',
                    show:true,
                    options:this.allaccounties.map(function(item){
                        return {
                            value:item.name,
                            label:item.name
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    },

                },
                {
                    label: "平台名称",
                    tag: 'vSelect',
                    key: 'EQ_siteName',
                    show:true,
                    options:mingcheng.map(function(item){
                        return {
                            value: item,
                            label: item
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "平台Shipping carrier",
                    tag: 'vSelect',
                    key: 'EQ_shippingCarrier',
                    options:shippingcarrier.map(function(item){
                        return {
                            value:item,
                            label:item
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    },
                    formItem:{
                        labelWidth:164,
                    }
                },
                {
                    label: "平台Shipping method code",
                    tag: 'vSelect',
                    key: 'EQ_shippingMethodCode',
                    options:shippingmethodcode.map(function(item){
                        return {
                            value: item,
                            label:item
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    },
                    formItem:{
                        labelWidth:164,
                    }
                },
                {
                    label: "系统发运方式",
                    tag: 'vSelect',
                    key: 'EQ_bossSmc',
                    // options:this.sysdeliveries.map(function(item){
                    options:this.newSysdeliveries.map(function(item){
                        // console.log(item)
                        // const {carrierServiceCode,carrierCode,carrierServiceName}=item;
                        const {carrierServiceCode,carrierCode,carrierService}=item;

                        return {
                            value: carrierServiceCode,
                            // label: carrierServiceCode +'( '+carrierCode+' '+carrierServiceName+' )'
                            label: carrierServiceCode +'( '+carrierCode+' '+carrierService+' )'
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "状态",
                    tag: 'vSelect',
                    key: 'EQ_status',
                    sortable: true,
                    options:[
                        {label:'有效',value:'ACTIVE'},
                        {label:'无效',value:'INACTIVE'}
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "平台所在国家",
                    tag: 'vSelect',
                    key: 'EQ_siteCountry',
                    options:this.countries.map(function(item){
                        // console.log(item)
                        const {code,nameEn} = item;
                        return {
                            value: code ? code : nameEn,
                            label: code + ' (' + nameEn + ')'
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                

            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: '操作',
                width: 70,
                render:this.getOperateNodes
            },
            {
                title: '平台名称/国家',
                key: 'bossSmc',
                render:(h,{row})=>{
                    return <div>
                        {row.siteName}
                        <div><span>{row.siteCountry}</span></div>
                        </div>
                }
            },
            {
                title: '平台发运方式',
                key: 'carrier/Code',
                render:(h,{row})=>{
                    return  <div>
                        <a onClick={this.handleOperates.bind(this, row.id, 'query')}><span>{row.shippingCarrier}</span><span v-show={row.shippingCarrier&&row.shippingMethodCode}>/</span><span>{row.shippingMethodCode}</span></a>
                        <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                }
            },
            {
                title: '系统发运方式',
                key: 'bossSmc',
            },
            {
                title: '回传发运方式',
                // key: 'bossSmc',
                render:(h,{row})=>{
                    return <div>{row.trackingMethodCarrier}<span v-show={row.trackingMethodCarrier&&row.trackingMethodCode}>/</span>{row.trackingMethodCode}</div>
                }
            },
            {
                title: '状态',
                key: 'status',
                maxWidth:80,
                sortable: true,
                render: (h, { row }) => {
                    const {label,theme}=row.status==='ACTIVE'?{
                        label:'有效',
                        theme:'success'
                    }:{
                        label:'失效',
                        theme:'error'
                    }
                    return <vButton ghost theme={theme} size="small" class="cursor-default width-60">{label}</vButton>
                }
            },
            {
                title: '创建时间',
                key: 'createdAt',
                sortable: true
            },
            {
                title: '更新时间',
                key: 'updatedAt',
                sortable: true
            }
        ];
        },

    },

};
